import { IPrintableError } from '@/error/IPrintableError'

export default class ApiError extends Error implements IPrintableError {
  private readonly _detail: string

  constructor(data: string, detail: string) {
    super(data)
    this.name = 'ApiError'
    this._detail = detail
  }

  public get detail() {
    return this._detail
  }

  getPrintableErrors(): string[] {
    return ['error.' + this.detail]
  }
}
